// extracted by mini-css-extract-plugin
export default {"wrapper":"QuestionExhibit_wrapper__tqREJ","image":"QuestionExhibit_image__j5cys","fallback":"QuestionExhibit_fallback__mH9Hc"};